<template>
  <div class="stage-item">
    <HeadLine>
      {{ $ml.get(data.Properties.StageName) }}
      <template v-if="$root.data.info[0]['value'] == 'soil-based'">
        ({{ duration }})
      </template>
    </HeadLine>
    <div class="body">
      <table class="th-table">
        <tr class="head">
          <td>
            {{$ml.get('Element')}}
          </td>
          <td>
            {{$ml.get('Test Result')}}
          </td>
        </tr>

        <tr 
          v-for="(item, index) in nuts" 
          v-if="index < nuts.length / 2"
        >
          <td>
            {{ item.key }}
          </td>
          <td>
            {{ parseFloat($store.getters['unit/convert'](unit, item.value)).toFixed(2) }} {{ $ml.get($store.getters['unit/getLabel'](unit)) }}
          </td>
        </tr>

      </table>
      <table class="th-table">
        <tr class="head">
          <td>
            {{$ml.get('Element')}}
          </td>
          <td>
            {{$ml.get('Test Result')}}
          </td>
        </tr>
  
        <tr 
          v-for="(item, index) in nuts" 
          v-if="index >= nuts.length / 2"
        >
          <td>
            {{ item.key }}
          </td>
          <td>
            {{ parseFloat($store.getters['unit/convert'](unit, item.value)).toFixed(2) }} {{ $ml.get($store.getters['unit/getLabel'](unit)) }}
          </td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import { log } from 'util';

export default {
  components: {
    HeadLine,
  },
  computed: {
    unit() {
      return this.$root.data.program.type == 'soil-based' ? 'kg' : 'ppm';
    },

    nuts() {
      const result = [];
      for (const nut in this.data.Nutrients) {
        result.push({
          key: nut,
          value: this.data.Nutrients[nut],
        });
      }
      return result.sort(this.$sortNutrients('key'));
      },
      duration() {
          const startDate = this.data.Properties.ActualDuration.split(' - ')[0];
          const endDate = this.data.Properties.ActualDuration.split(' - ')[1];
          return startDate.split(' ')[0] + ' ' + this.$ml.get(startDate.split(' ')[1]) + ' ' + startDate.split(' ')[2] + ' - ' + endDate.split(' ')[0] + ' ' + this.$ml.get(endDate.split(' ')[1]) + ' ' + endDate.split(' ')[2];
      },
  },
  props: {
    data: {}
  }
}
</script>

<style lang="scss" scoped>

.stage-item {
  .head-line {
    margin-bottom: 10px;
  }

  .body {
    display: flex;
    flex-direction: row;
    justify-content: center;

    table {
      flex-grow: 1;
      max-width: 280px;

      &:first-child {
        margin-right: 20px;
      }
    }
  }
}

</style>